import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Flex, MenuLinkButton } from '@/components/common';
import { AccountSubpageShell } from '@/components/layout';

const HELP_LEGAL_LINKS = [
  {
    to: '/account/settings/help',
    titleKey: 'hub.help.title' as const,
    subtitleKey: 'hub.help.subtitle' as const,
  },
  {
    to: '/account/settings/about',
    titleKey: 'hub.legal.title' as const,
    subtitleKey: 'hub.legal.subtitle' as const,
  },
];

export function HelpLegalPage() {
  const { t } = useTranslation('settings');
  const navigate = useNavigate();

  return (
    <AccountSubpageShell onBack={() => navigate('/account')} title={t('helpLegal.title')}>
      <Flex direction="column" gap="3">
        {HELP_LEGAL_LINKS.map(({ to, titleKey, subtitleKey }) => (
          <MenuLinkButton
            key={to}
            to={to}
            title={t(titleKey)}
            subtitle={t(subtitleKey)}
            data-testid={to.replace(/\//g, '-').slice(1)}
          />
        ))}
      </Flex>
    </AccountSubpageShell>
  );
}
